import { useState, useRef, useEffect } from 'react';
import { graphql } from 'react-relay';
import { useTranslation, Markdown } from '@/helpers/translate';
import Icon from '@/core/icon.js';

const fragment = graphql`
  fragment descriptionSpacePublic_item on Space @argumentDefinitions(
    lang : {type:"String!"}
  ) {
    descriptionByLang(lang:$lang)
    description
  }
`;

function Description({ item: paramItem }) {
  const divRef = useRef();
  let item = paramItem;

  if (!item) item = {};
  const { t } = useTranslation();
  const [switchDesc, setSwitchDesc] = useState(false);
  const [hasOriginal] = useState(item?.descriptionByLang
    && item?.descriptionByLang !== item?.description);
  const [fullText, setFullText] = useState(false);
  const [showBtnMore, setShowBtnMore] = useState(false);

  const getDescription = () => {
    const description = switchDesc ? item.description : item.descriptionByLang;
    return !hasOriginal ? item.description : description;
  };

  const isSmallDescription = () => {
    const text = getDescription();
    const lines = text ? text.split('\n') : [];
    return lines.length <= 10;
  };

  useEffect(() => {
    if (divRef.current) {
      const lineHeight = parseFloat(getComputedStyle(divRef.current).lineHeight);
      const height = divRef.current.clientHeight;
      const numLines = height / lineHeight;
      if (numLines > 15 || !isSmallDescription()) {
        setShowBtnMore(true);
      }
    }
  }, [switchDesc]);

  return (
    <section className="flex-col text-purple-6/50 md:flex-row md:pt-8">
      <div className="relative w-full pb-2 lg:pb-0">
        {hasOriginal ? (
          <button className="flex items-center justify-between w-full px-4 py-3 mb-4 border cursor-pointer text-purple-6/50 border-white-dark2 group hover:bg-purple/10 hover:text-purple hover:border-purple/50 hover:bg-purple/5" onClick={() => setSwitchDesc(!switchDesc)}>
            {!switchDesc ? t('btn:translation.original') : t('btn:translation.translated')}
            <Icon className="fill-current text-purple-5/50 w-7 h-7 group-hover:text-purple" name="translate" />
          </button>
        ) : null}
        <div ref={divRef} className="overflow-hidden">
          <Markdown className={`transition text-base leading-relaxed ${!fullText ? 'max-h-[310px]' : 'max-h-full'}`}>{getDescription()}</Markdown>
        </div>
        {(fullText || !showBtnMore) || <div className="absolute bottom-0 w-full h-24 gradient-towhite" />}
      </div>
      {showBtnMore && <div className="flex items-center mt-3 gap-x-2">
        <svg className={`${!fullText ? 'rotate-90' : '-rotate-90'}`} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.60366 0.646447C9.4084 0.451184 9.09182 0.451184 8.89656 0.646447C8.70129 0.841709 8.70129 1.15829 8.89656 1.35355L9.60366 0.646447ZM12.6466 5.10355C12.8418 5.29882 13.1584 5.29882 13.3537 5.10355C13.5489 4.90829 13.5489 4.59171 13.3537 4.39645L12.6466 5.10355ZM13.3537 5.10355C13.5489 4.90829 13.5489 4.59171 13.3537 4.39645C13.1584 4.20118 12.8418 4.20118 12.6466 4.39645L13.3537 5.10355ZM8.89656 8.14645C8.70129 8.34171 8.70129 8.65829 8.89656 8.85355C9.09182 9.04882 9.4084 9.04882 9.60366 8.85355L8.89656 8.14645ZM13.0001 5.25C13.2763 5.25 13.5001 5.02614 13.5001 4.75C13.5001 4.47386 13.2763 4.25 13.0001 4.25V5.25ZM1.24854 4.25C0.972393 4.25 0.748535 4.47386 0.748535 4.75C0.748535 5.02614 0.972393 5.25 1.24854 5.25V4.25ZM8.89656 1.35355L12.6466 5.10355L13.3537 4.39645L9.60366 0.646447L8.89656 1.35355ZM12.6466 4.39645L8.89656 8.14645L9.60366 8.85355L13.3537 5.10355L12.6466 4.39645ZM13.0001 4.25H1.24854V5.25H13.0001V4.25Z" fill="black" />
        </svg>
        <button className="py-0.5 text-sm font-medium border-b rounded-none border-purple-6 text-purple-6" onClick={() => setFullText(!fullText)}>{!fullText ? t('btn:see_more_desc') : t('btn:see_less_desc')}</button>
                      </div>}
    </section>
  );
}

export { fragment };

export default Description;
